<template>
    <div class="item" :style="itemStyle">
      <img class="icon" :src="icon" v-if="icon"/>
      <div class="title">{{title}}</div>
      <div class="value">{{value}}</div>
    </div>
</template>

<script>
  export default {
    props:["icon","title","value",'bgColor', 'color'],
    data() {
      return {
        itemStyle: ''
      }
    },
    mounted() {
      this.itemStyle = {
        color: this.color,
        background: this.bgColor
      }
    }
  }
</script>

<style scoped>
.item{
  display: flex;
  align-items: center;
  margin-right: 15px;
  border-radius: 3px;
  padding: 0 16px 0 10px;
  background: #f5f9fa;
  height: 55px;
  border: 1px solid rgba(222,222,222,0.1);
}

  .icon{
    width: 30px;
    height: 30px;
    vertical-align: middle;
    margin-right: 8px;
  }

.title {
  margin-right: 20px;
  font-size: 16px;
  color: #888888;
}

.value {
  font-size: 22px;
  /* color: #0084ff; */
}

</style>



// WEBPACK FOOTER //
// src/components/common/StatisticsDataItem.vue